export default class Shell {
    static BatchId = "batchId";
    static AccessCode = "AccessCode";
    static Environment = "Environment";
    static LocationId = "LocationID";
    static LocationName = "LocationName";
    static RegisterName = "RegisterName";
    static IsRegisterEnabled = "IsRegisterEnabled";
    static Brand = "Brand";
    static KioskName = "KioskName";
    static NetworkAvailabilityUrl = "NetworkAvailabilityUrl";
}

